<template>
  <div class="flex items-center">
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ partnerLocal.company }}</router-link>
  </div>


</template>



<script>

// Здесь можно два варианта, так
// export default {
//   name: 'CellRendererPartner',
//   computed: {
//     partnerLocal() {
//       return this.$store.getters["partner/getPartner"] ? this.$store.getters["partner/getPartner"] : { company: '...' }
//     },
//   },
//   created() {
//     this.$store.dispatch("partner/fetchPartner", { partid: this.params.value })
//   }
// }

// или так
export default {
  name: 'CellRendererPartner',
  computed: {
    partnerLocal() {
      return this.$store.getters["partner/getPartneri"](this.params.value) ? this.$store.getters["partner/getPartneri"](this.params.value) : { company: '...' }
    },
    url() {
      return "/apps/partners/view/" + this.partnerLocal.partid
    }
  },
}

</script>
